import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleGT8HWIF = () => {
  console.log('🎯 SimpleGT8HWIF component loading');
  
  const product = findProductById("gt8hw-if");
  
  if (!product) {
    console.error('Product not found:', "gt8hw-if");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="gt8hw-if"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleGT8HWIF; 